// frontend/src/config/basemapsConfig.js
import {
  SHARED_BOUNDARIES,
  SHARED_LABELS,
  SHARED_ROADS
} from "./sharedOverlayLayers";

const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

// Default center/zoom for thumbnails
const CENTER_LON = -70;
const CENTER_LAT = 40;
const ZOOM = 3;
const THUMBNAIL_SIZE = "80x80";

const getMapboxStaticImage = (styleId) => {
  return `https://api.mapbox.com/styles/v1/mapbox/${styleId}/static/${CENTER_LON},${CENTER_LAT},${ZOOM}/${THUMBNAIL_SIZE}@2x?access_token=${MAPBOX_ACCESS_TOKEN}`;
};

const basemapsConfig = [
    {
    id: "light",
    name: "Light",
    style: "mapbox://styles/mapbox/light-v10",
    thumbnail: getMapboxStaticImage("light-v10"),
    overlayLayers: {
      boundaries: SHARED_BOUNDARIES,
      labels: SHARED_LABELS,
      roads: SHARED_ROADS
    }
  },
  {
    id: "streets",
    name: "Streets",
    style: "mapbox://styles/mapbox/streets-v11",
    thumbnail: getMapboxStaticImage("streets-v11"),
    overlayLayers: {
      boundaries: SHARED_BOUNDARIES,
      labels: SHARED_LABELS,
      roads: SHARED_ROADS
    }
  },
  {
    id: "satellite-streets",
    name: "Satellite",
    style: "mapbox://styles/mapbox/satellite-streets-v11",
    thumbnail: getMapboxStaticImage("satellite-v9"),
    overlayLayers: {
      // If you want the same arrays for every style:
      boundaries: SHARED_BOUNDARIES,
      labels: SHARED_LABELS,
      roads: SHARED_ROADS

      // Or you can do partial overrides, e.g.:
      // roads: [...SHARED_ROADS, "some-other-road-layer"],
      // labels: SHARED_LABELS.filter(id => id !== "road-label")
    }
  },
  {
    id: "outdoors",
    name: "Topography",
    style: "mapbox://styles/mapbox/outdoors-v11",
    thumbnail: getMapboxStaticImage("outdoors-v11"),
    overlayLayers: {
      boundaries: SHARED_BOUNDARIES,
      labels: SHARED_LABELS,
      roads: SHARED_ROADS
    }
  },
  {
    id: "dark",
    name: "Dark",
    style: "mapbox://styles/mapbox/dark-v10",
    thumbnail: getMapboxStaticImage("dark-v10"),
    overlayLayers: {
      boundaries: SHARED_BOUNDARIES,
      labels: SHARED_LABELS,
      roads: SHARED_ROADS
    }
  },

];

export default basemapsConfig;
